import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { BookingManagerContainer } from './';
import { compose } from 'redux';
import { RouteComponentProps } from 'react-router';

export interface IBookingManagerRouting extends RouteComponentProps {}

const BookingManagerRoutingComponent = (props: IBookingManagerRouting) => {
  return (
    <Switch>
      <Route path={`${props.match.path}/:bookingUuid`} component={BookingManagerContainer} />
    </Switch>
  );
};

export const BookingManagerRouting = compose(withRouter)(BookingManagerRoutingComponent);
